import { useState } from 'react';
import { heroStats } from '@/mocks/home';

interface HeroProps {
  onSearch: (keyword: string) => void;
}

const quickLinks = [
  { label: '今日热议', href: '#trending' },
  { label: '话题分类', href: '#categories' },
  { label: '最新瓜料', href: '#articles' },
];

export default function Hero({ onSearch }: HeroProps) {
  const [keyword, setKeyword] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSearch(keyword.trim());
  };

  return (
    <section id="top" className="relative w-full h-[620px] md:h-[740px] overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20collage%20of%20warm%20spotlights%20and%20glowing%20particles%20on%20a%20deep%20charcoal%20background%2C%20coral%20and%20amber%20color%20accents%2C%20moody%20entertainment%20magazine%20aesthetic%2C%20soft%20bokeh%20glow&width=1600&height=900&seq=hcg-hero-01&orientation=landscape"
          alt="黑吃瓜网首页背景，暖色聚光灯与话题氛围主题插画"
          title="黑吃瓜网 吃瓜群众热议话题聚集地"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75"></div>

      <div className="relative z-10 w-full h-full flex items-center justify-center px-4 md:px-8">
        <div className="w-full max-w-3xl text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs md:text-sm mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            此刻全网站都在聊
          </span>

          <h1 className="font-heading font-black text-3xl md:text-6xl text-background-50 leading-tight tracking-tight">
            黑吃瓜网
            <span className="block mt-2 text-xl md:text-3xl text-accent-400 font-bold">
              吃瓜群众的聚集地
            </span>
          </h1>

          <p className="mt-6 text-sm md:text-base text-background-100/90 leading-relaxed max-w-xl mx-auto">
            今日热议话题、最新娱乐瓜料、话题分类与瓜友交流，都在这里。不用在几个平台之间来回切换，看懂来龙去脉，再和大家一起把瓜聊透。
          </p>

          <form
            onSubmit={handleSubmit}
            className="mt-8 w-full max-w-xl mx-auto flex flex-col sm:flex-row gap-3"
            role="search"
          >
            <div className="relative flex-1">
              <span className="absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg">
                <i className="ri-search-line" aria-hidden="true"></i>
              </span>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜瓜：剧集口碑、音乐节、造型盘点…"
                aria-label="搜索话题与瓜料"
                className="w-full h-12 pl-11 pr-4 rounded-md bg-background-50 text-foreground-950 text-sm placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-400"
              />
            </div>
            <button
              type="submit"
              className="h-12 px-7 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              开始搜瓜
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
            {quickLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-4 py-1.5 rounded-full border border-background-50/30 text-background-50/90 text-xs md:text-sm hover:bg-background-50/15 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-3 gap-3 md:gap-6 max-w-lg mx-auto border-t border-background-50/15 pt-6">
            {heroStats.map((stat) => (
              <div key={stat.id} className="text-center">
                <p className="font-heading font-black text-xl md:text-3xl text-accent-400">
                  {stat.value}
                </p>
                <p className="mt-1 text-[11px] md:text-xs text-background-200/85">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}